import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=80b2f4f8&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"
import style0 from "./CalendarComponent.vue?vue&type=style&index=0&id=80b2f4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b2f4f8",
  null
  
)

export default component.exports